"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title;
  return (0, _preact.h)("div", {
    className: "m-modal--header"
  }, (0, _preact.h)("h3", {
    className: "m-modal--header_title"
  }, (0, _preact.h)("strong", null, title)));
};

exports.ModalHeader = ModalHeader;

var ModalFooter = function ModalFooter(_ref2) {
  var children = _ref2.children;
  return (0, _preact.h)("div", {
    className: "m-modal--footer"
  }, children);
};

exports.ModalFooter = ModalFooter;

var ModalBody = function ModalBody(_ref3) {
  var children = _ref3.children;
  return (0, _preact.h)("div", {
    className: "m-modal--body"
  }, children);
};

exports.ModalBody = ModalBody;

var ModalContainer = function ModalContainer(_ref4) {
  var children = _ref4.children,
      onClose = _ref4.onClose,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'M' : _ref4$variant,
      _ref4$isControl = _ref4.isControl,
      isControl = _ref4$isControl === void 0 ? false : _ref4$isControl,
      _ref4$isHeightAdjusta = _ref4.isHeightAdjustable,
      isHeightAdjustable = _ref4$isHeightAdjusta === void 0 ? true : _ref4$isHeightAdjusta,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === void 0 ? 'vertical' : _ref4$direction,
      onBackdropClick = _ref4.onBackdropClick,
      modalref = _ref4.modalref,
      customClass = _ref4.customClass;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('o-modal_container', customClass)
  }, (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.backdrop",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("div", {
      className: "o-modal--opacity",
      onClick: onBackdropClick,
      role: "button",
      tabIndex: 0,
      "aria-label": accessibilityLabel,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          onBackdropClick === null || onBackdropClick === void 0 ? void 0 : onBackdropClick();
          e.stopPropagation();
        }
      }
    });
  }), (0, _preact.h)("div", {
    className: (0, _classnames.default)('o-modal', "o-modal--size-".concat(variant), "o-modal--direction-".concat(direction), {
      'o-modal--app-control': isControl,
      'o-modal--app-destination': !isControl,
      'o-modal--app-fix-height': !isHeightAdjustable
    }),
    ref: modalref
  }, (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.close",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("span", {
      onClick: onClose,
      role: "button",
      tabIndex: 0,
      "aria-label": accessibilityLabel,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          onClose === null || onClose === void 0 ? void 0 : onClose();
          e.stopPropagation();
        }
      }
    }, (0, _preact.h)(_Close.default, {
      width: 24,
      height: 24,
      fill: "currentColor",
      className: "o-modal--close"
    }));
  }), children));
};

var Modal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastActiveElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "modalRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "activeElement", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusFirstElement", function () {
      var focusableElements = "a[href], area[href], input, select, textarea, button,\n                                iframe, object, embed, [tabindex]:not([tabindex=\"-1\"]), [contenteditable]";
      var modal = _this.modalRef.current;
      if (!modal) return;
      var firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
      if (firstFocusableElement instanceof HTMLElement) firstFocusableElement.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTabKeyWithElements", function (e) {
      var focusableElements = "a[href], area[href], input, select, textarea, button,\n                                iframe, object, embed, [tabindex]:not([tabindex=\"-1\"]), [contenteditable]";
      var modal = _this.modalRef.current;
      if (!modal) return;
      var focusableContent = modal.querySelectorAll(focusableElements);
      var firstFocusableElement = focusableContent[0];
      var lastFocusableElement = focusableContent[focusableContent.length - 1];

      _this.handleTabKey(e, firstFocusableElement, lastFocusableElement);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      if (event.key === 'Escape') {
        _this.activeElement.current = document.activeElement;

        if (_this.activeElement.current instanceof HTMLElement) {
          var _this$props$onClose, _this$props;

          var isInputFocused = _this.activeElement.current && (_this.activeElement.current.tagName === 'INPUT' || _this.activeElement.current.tagName === 'TEXTAREA' || _this.activeElement.current.isContentEditable);
          if (!isInputFocused) (_this$props$onClose = (_this$props = _this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props);else _this.activeElement.current.blur();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTabKey", function (event, firstElement, lastElement) {
      if (event.key !== 'Tab') return;
      _this.activeElement.current = document.activeElement;

      if (event.shiftKey && _this.activeElement.current === firstElement) {
        if (lastElement instanceof HTMLElement) lastElement.focus();
        event.preventDefault();
        return;
      }

      if (!event.shiftKey && _this.activeElement.current === lastElement) {
        if (firstElement instanceof HTMLElement) firstElement.focus();
        event.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.disableScrollLock) {
        document.body.style.overflow = 'hidden';
      }

      this.lastActiveElement = document.activeElement;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
      document.addEventListener('keydown', this.handleTabKeyWithElements);
      this.focusFirstElement();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.disableScrollLock) {
        document.body.style.overflow = 'auto';
      }

      if (this.lastActiveElement instanceof HTMLElement) this.lastActiveElement.focus();
      document.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('keydown', this.handleTabKeyWithElements);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(ModalContainer, (0, _extends2.default)({}, this.props, {
        modalref: this.modalRef
      }));
    }
  }]);
  return Modal;
}(_preact.Component);

var _default = Modal;
exports.default = _default;